export interface Item {
  desc: string;
  i18n?: string;
  id: number;
  regions?: string[];
  formTypes?: string[];
}

export interface ILeadFormResult {
  industry: Item[];
  isAgency: Item[];
  monthlyBudget: Item[];
  submissionPageType: Item[];
  competitorPlatformUsed: Item[];
  marketingObjective: Item[];
  title: Item[];
  businessRole: Item[];
  marketingDestination: Item[];
  considerTiktokAds: Item[];
}
export interface ICommonResult {
  pdfUrls: Record<string, string>;
  redirectWhitelist: string[];
}

// 线索来源	submission_page_type
// 	DEFAULT = 0
// 注册流程中填写未开自助的国家	REGISTER NO SELF SERVE = 5
// 注册流程中碰到高峰限制	REGISTER EXEED DAILY QUOTA = 6
// 线索落地页	LEAD LANDING PAGE = 7
// 注册流程中自助国家填写个人	REGISTER INDIVIDUAL = 11
// Lead pages自定义表单	CUSTOM FORM = 12
// IP和注册国家不匹配（仅限欧美）IP NON MATCH = 13

export enum SubmissionPageType {
  REGISTER_NO_SELF_SERVE = 5,
  REGISTER_EXEED_DAILY_QUOTA = 6,
  LEAD_LANDING_PAGE = 7,
  REGISTER_INDIVIDUAL = 11,
  CUSTOM_FORM = 12,
  IP_NON_MATCH = 13,
  WECHAT = 18,
  CUSTOM_FORM_SEA_ONLY = 19
}

export const initLeadFormResult = {
  industry: [],
  isAgency: [],
  monthlyBudget: [],
  submissionPageType: [],
  competitorPlatformUsed: [],
  marketingObjective: [],
  title: [],
  businessRole: [],
  marketingDestination: [],
  considerTiktokAds: []
};

export type IShopifyBlack = {
  businessName: string;
  url: string;
  logo: string;
}[];
